<div *ngIf="this.loadingHotkey$ | async; else loadingHotkeys" class="formgrid">
  <div
    class="surface-card shadow-2 flex align-items-center justify-content-center h-screen"
  >
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>
<ng-template #loadingHotkeys>
  <p-toast key="hotkeys"></p-toast>
  <div
    class="block overflow-hidden surface-overlay w-full"
    style="max-width: 100vw"
  >
    <div class="m-4">
      <p-table
        #dt
        [value]="(hotkey$ | async) || []"
        [rowHover]="true"
        responsiveLayout="scroll"
        scrollHeight="75vh"
        scrollDirection="both"
        [scrollable]="true"
        [responsive]="true"
        [tableStyle]="{ 'min-width': '70rem' }"
        styleClass="app-table p-datatable-sm lg:p-datatable-md"
        [globalFilterFields]="[
          'hotkey_main',
          'main_description',
          'descriptions.tag_description',
          'descriptions.hotkey_tag'
        ]"
      >
        <ng-template pTemplate="caption">
          <div
            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
          >
            <div class="flex flex-wrap gap-2">
              <button
                pButton
                type="button"
                icon="pi pi-plus"
                label="Add Hotkey"
                class="p-button-sm p-button-outlined"
                (click)="showCreateHotkeyDialog()"
              ></button>
            </div>

            <div class="w-full md:w-auto">
              <span class="p-input-icon-left p-input-icon-right w-full">
                <i class="pi pi-search"></i>
                <input
                  pInputText
                  type="text"
                  class="w-full md:w-20rem"
                  [value]="searchValue"
                  (input)="filterGlobal($event)"
                  placeholder="Search keyword"
                />
                <i
                  *ngIf="searchValue"
                  class="pi pi-times"
                  style="cursor:pointer"
                  (click)="clearSearch()"
                ></i>
              </span>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              <div class="flex align-items-center">
                <span>{{ col.header }}</span>
                <p-columnFilter
                  type="text"
                  [field]="col.field"
                  display="menu"
                ></p-columnFilter>
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-hotkey>
          <tr>
            <td>
              <span>{{ hotkey.hotkey_main }}</span>
            </td>

            <td>
              <span>{{ hotkey.main_description }}</span>
            </td>

            <td>
              <div class="flex flex-wrap gap-2">
                <ng-container *ngFor="let description of hotkey.descriptions">
                  <div
                    *ngIf="description.hotkey_tag"
                    class="flex align-items-center gap-2 border-1 surface-border border-round px-2 py-2 surface-card"
                  >
                    <span class="font-medium text-900">
                      {{ description.hotkey_tag }}
                    </span>

                    <span class="text-700">
                      {{ description.tag_description }}
                    </span>

                    <button
                      type="button"
                      pButton
                      icon="pi pi-pencil"
                      class="p-button-sm p-button-text"
                      (click)="showUpdateTagDialog(description)"
                    ></button>

                    <button
                      type="button"
                      pButton
                      icon="pi pi-times"
                      class="p-button-sm p-button-text p-button-danger"
                      (click)="deleteTag(description)"
                    ></button>
                  </div>
                </ng-container>
              </div>
            </td>

            <td class="text-right">
              <button
                type="button"
                pButton
                icon="pi pi-ellipsis-v"
                class="p-button-sm p-button-text p-button-secondary"
                (click)="
                  menu.toggle($event);
                  storeRowDetail(hotkey);
                  $event.stopPropagation()
                "
              ></button>

              <p-menu
                #menu
                [model]="items"
                [popup]="true"
                appendTo="body"
              ></p-menu>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">
              <div class="flex align-items-center justify-content-center py-4">
                <span class="text-800 font-medium text-xl"> No hotkeys </span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <p-confirmDialog #cd>
    <p-footer>
      <button
        pButton
        type="button"
        label="No"
        class="p-button-primary"
        (click)="cd.reject()"
      ></button>
      <button
        pButton
        type="button"
        label="Yes"
        class="p-button-danger"
        (click)="cd.accept()"
      ></button>
    </p-footer>
  </p-confirmDialog>
</ng-template>

<p-confirmDialog key="archiveIssue"></p-confirmDialog>
